module.exports = __webpack_public_path__ + "static/media/ErasITC-Bold.2e8d0e15.woff";